export default "__VITE_ASSET__4j6WYQYz__"